import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { WebsiteData } from '../../shared/models/website-overview.model';
import { WebsiteStoreService } from '../services/website-store.service';
import moment from 'moment';

export const websiteResolver: ResolveFn<WebsiteData> = (route) => {
  const websiteStore = inject(WebsiteStoreService);

  return websiteStore.loadWebsiteData(
    +route.paramMap.get('id')!,
    moment().utc().startOf('month').unix(),
    moment().utc().endOf('month').unix(),
  );
};
